// Config
export const AXIOS_TIMEOUT = 10000;
export const FORCED_CANCELLATION = 'ERR_CANCELED';
export const FORCED_CANCELLATION_MESSAGE = 'Forced cancellation';
export const DATA_FETCH_ERROR = 'Data Fetch Error';
export const TIMEOUT_CANCELLATION = 'ECONNABORTED';
export const axiosTimeoutConfig = { timeout: AXIOS_TIMEOUT };

// Global
export const SET_CERT_LIST_CAMPAIGNKEY = 'CERTLIST/SET_CERT_LIST_CAMPAIGNKEY';
export const UPDATE_SCREEN_SIZE = 'CERTLIST/UPDATE_SCREEN_SIZE';
export const SET_TOUCH_DEVICE_STATUS = 'CERTLIST/SET_TOUCH_DEVICE_STATUS';
export const SET_CERT_GLOBAL_DATE_FORMAT =
  'CERTLIST/SET_CERT_GLOBAL_DATE_FORMAT';
export const SET_CERT_LIST_IS_WITHOUT_CAMPAIGN_KEY =
  'CERTLIST/SET_CERT_LIST_IS_WITHOUT_CAMPAIGN_KEY';
export const SET_CERTS_TIME_ZONE = 'CERTLIST/SET_CERTS_TIME_ZONE';
export const SET_CERT_LIST_GLOBAL_LOADING =
  'CERTLIST/SET_CERT_LIST_GLOBAL_LOADING';
export const CERT_LIST_GLOBAL_ERROR = 'CERTLIST/CERT_LIST_GLOBAL_ERROR';

// Core
export const VIEW_API_FAIL_MESSAGE =
  'Not able to load the page configurations. Please try again later.';
export const SET_CERT_LIST_IS_PAGE_LOAD_FINISHED =
  'CERTLIST/SET_CERT_LIST_IS_PAGE_LOAD_FINISHED';
export const SET_CERT_LIST_TOTAL_ITEMS_COUNT =
  'CERTLIST/SET_CERT_LIST_TOTAL_ITEMS_COUNT';
export const SET_CERT_LIST_RECENT_DATA = 'CERTLIST/SET_CERT_LIST_RECENT_DATA';
export const SET_CERT_LIST_IS_FIRST_LIST_LOAD_FINISHED =
  'CERTLIST/SET_CERT_LIST_IS_FIRST_LIST_LOAD_FINISHED';
export const SET_CERT_LIST_IS_RELOAD_REQUIRED =
  'CERTLIST/SET_CERT_LIST_IS_RELOAD_REQUIRED';
export const SET_CERT_LIST_OFFSET = 'CERTLIST/SET_CERT_LIST_OFFSET';
export const SET_CERT_LIST_HAS_ADMIN_ROLE =
  'CERTLIST/SET_CERT_LIST_HAS_ADMIN_ROLE';
export const SET_CERT_LIST_HAS_AUDITOR_LOGGED_IN =
  'CERTLIST/SET_CERT_LIST_HAS_AUDITOR_LOGGED_IN';
export const SET_CERT_LIST_IS_CONSULTEE_LOGIN =
  'CERTLIST/SET_CERT_LIST_IS_CONSULTEE_LOGIN';
export const SET_CERT_LIST_CAMPAIGN_INFO =
  'CERTSLIST/SET_CERT_LIST_CAMPAIGN_INFO';
export const SET_PREDEFINED_COMMENTS = 'CERTSLIST/SET_PREDEFINED_COMMENTS';
export const SET_CERT_LIST_TRANSITION_ID =
  'CERTSLIST/SET_CERT_LIST_TRANSITION_ID';
export const SET_CERT_LIST_CURRENT_ACTION =
  'CERTSLIST/SET_CERT_LIST_CURRENT_ACTION';
export const SET_CERT_LIST_ONE_TILE_ACTIONABLE =
  'CERTSLIST/SET_CERT_LIST_ONE_TILE_ACTIONABLE';

// Sidepanels
export const SET_CERT_LIST_SIDEPANEL_VISIBLE =
  'CERTLIST/SET_CERT_LIST_SIDEPANEL_VISIBLE';
export const SET_CERT_LIST_CONNECTED_TILE_ID =
  'CERTSLIST/SET_CERT_LIST_CONNECTED_TILE_ID';
export const SET_CERT_LIST_SIBLINGS_TILE_ID =
  'CERTSLIST/SET_CERT_LIST_SIBLINGS_TILE_ID';
export const SET_CERTS_LIST_SIDEPANEL_LOADING =
  'CERTSLIST/SET_CERTS_LIST_SIDEPANEL_LOADING';
export const SET_CERTS_LIST_SIDEPANEL_METADATA =
  'CERTSLIST/SET_CERTS_LIST_SIDEPANEL_METADATA';
// TODO: This is the temp state till the time Carousel is updated for BreadCrumb
export const SET_CERTS_LIST_SIDEPANEL_TEMP_ACTION_STATE =
  'CERTSLIST/SET_CERTS_LIST_SIDEPANEL_TEMP_ACTION_STATE';

// Line Actions
export const SET_CERT_LIST_ACTION_IS_LOADING =
  'CERTLIST/SET_CERT_LIST_ACTION_IS_LOADING';
export const SET_CERT_LIST_ACTION_DISCONTINUE =
  'CERTLIST/SET_CERT_LIST_ACTION_DISCONTINUE';
export const SET_CERT_LIST_COLUMN_PICKER_LIST_IS_LOADING =
  'CERTLIST/SET_CERT_LIST_COLUMN_PICKER_LIST_IS_LOADING';
export const SET_CERT_LIST_COLUMN_PICKER_LIST =
  'CERTLIST/SET_CERT_LIST_COLUMN_PICKER_LIST';
export const SET_CERT_LIST_COLUMN_OBJECTS_TO_BE_INCLUDED =
  'CERTLIST/SET_CERT_LIST_COLUMN_OBJECTS_TO_BE_INCLUDED';
export const SET_CERT_LIST_COLUMN_PICKER_ERROR =
  'CERTLIST/SET_CERT_LIST_COLUMN_PICKER_ERROR';
export const CERTS_LIST_EXPORT_COLUMNS_TO_EXPORT =
  'CERTLIST/CERTS_LIST_EXPORT_COLUMNS_TO_EXPORT';
export const CERTS_LIST_EXPORT_STATUS = 'CERTLIST/CERTS_LIST_EXPORT_STATUS';
export const CERTS_LIST_RESET_EXPORT_STATUS =
  'CERTLIST/CERTS_LIST_RESET_EXPORT_STATUS';
export const CERTS_LIST_DISCONTINUE_STATUS =
  'CERTLIST/CERTS_LIST_DISCONTINUE_STATUS';
export const CERTS_LIST_REASSIGN_STATUS = 'CERTLIST/CERTS_LIST_REASSIGN_STATUS';
export const SET_CERT_LIST_ACTION_STATUS =
  'CERTLIST/SET_CERT_LIST_ACTION_STATUS';
export const SET_CERT_LIST_ACTION_ERROR = 'CERTLIST/SET_CERT_LIST_ACTION_ERROR';
export const SET_CERTS_LIST_EMAIL_HISTORY =
  'CERTLIST/SET_CERTS_LIST_EMAIL_HISTORY';

// Bulk Actions
export const SET_CERT_LIST_IS_BULK_ACTION_ENABLED =
  'CERTLIST/SET_CERT_LIST_IS_BULK_ACTION_ENABLED';
export const SET_CERT_LIST_IS_BULK_SELECT_CHECKED =
  'CERTLIST/SET_CERT_LIST_IS_BULK_SELECT_CHECKED';
export const SET_CERT_LIST_BULK_FOOTER_VISIBLE =
  'CERTLIST/SET_CERT_LIST_BULK_FOOTER_VISIBLE';
export const SET_CERT_LIST_IS_BULK_DISABLED =
  'CERTLIST/SET_CERT_LIST_IS_BULK_DISABLED';
export const SET_CERT_LIST_IS_SUBMITTING_BULK_ACTION =
  'CERTLIST/SET_CERT_LIST_IS_SUBMITTING_BULK_ACTION';
export const SET_CERT_LIST_IS_BULK_INTERMIDIATE =
  'CERTLIST/SET_CERT_LIST_IS_BULK_INTERMIDIATE';
export const SET_CERT_LIST_IS_SELECTING_BULK =
  'CERTLIST/SET_CERT_LIST_IS_BULK_INTERMIDIATE';

// Tabs
export const SET_ACTIVE_TAB = 'CERTLIST/SET_ACTIVE_TAB';
export const SET_TAB_COUNT = 'CERTLIST/SET_TAB_COUNT';
export const SET_ALL_TABS_COUNT = 'CERTLIST/SET_ALL_TABS_COUNT';
export const SET_EXPORT_LOADING = 'CERTLIST/SET_EXPORT_LOADING';

// View Controls
export const SET_DYNAMIC_SORT_FILTER_DETAILS =
  'CERTLIST/SET_DYNAMIC_SORT_FILTER_DETAILS';
export const RESET_DYNAMIC_SORT_FILTER_DETAILS =
  'CERTLIST/RESET_DYNAMIC_SORT_FILTER_DETAILS';
export const SET_SEARCH_TEXT_VALUE = 'CERTLIST/SET_SEARCH_TEXT_VALUE';

export const SET_ROLE_FILTER = 'CERTLIST/SET_ROLE_FILTER';
export const SET_APPLIED_ROLE_FILTERS = 'CERTLIST/SET_APPLIED_ROLE_FILTERS';
